import wrapURL from './intercepter';

const transV2Service = wrapURL(process.env.VUE_APP_ENV === 'production' 
  ? 'https://api.vibrant-america.com/v2/portal/trans-service'
  : 'https://api.vibrant-america.com/v2/portal/trans-service-st');

export default transV2Service;